import { FC } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';

export const LegacyChatRedirect: FC<RouteComponentProps> = ({ match }) => (
  <Redirect to={`${match.url.replace(/\/chat\/?$/i, '')}/settings/users`} />
);
